export default __webpack_public_path__ + "media/zurb/img/lab/thumbnails/resp-email-templates-3fda91670095a59c41c07e7314a189c9.jpg";